import React from 'react';
import propTypes from 'prop-types';

export const HotelIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 1024.000000 1024.000000"
      preserveAspectRatio="xMidYMid meet"
      className={variant}
    >
      <g
        transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none"
      >
        <path
          d="M4930 9684 c-368 -27 -809 -121 -1195 -254 -335 -116 -755 -324
-1055 -523 -303 -202 -634 -493 -885 -777 -191 -216 -438 -562 -568 -796 -335
-601 -521 -1217 -578 -1909 -15 -182 -6 -766 14 -930 171 -1390 918 -2596
2062 -3326 165 -106 565 -310 786 -402 576 -240 1225 -360 1854 -343 486 13
889 81 1345 228 908 291 1792 943 2321 1709 468 680 738 1424 821 2264 19 198
16 744 -5 927 -58 488 -175 926 -369 1373 -116 268 -216 452 -383 705 -452
684 -1076 1230 -1820 1595 -469 229 -916 364 -1445 436 -126 17 -219 21 -500
24 -190 1 -370 1 -400 -1z m765 -749 c432 -51 841 -174 1240 -373 385 -192
639 -369 955 -666 689 -646 1125 -1520 1216 -2439 23 -230 15 -753 -15 -947
-95 -625 -277 -1112 -596 -1595 -546 -824 -1389 -1423 -2317 -1645 -539 -128
-1099 -140 -1653 -34 -820 157 -1623 614 -2172 1236 -544 617 -860 1337 -954
2178 -17 150 -17 639 -1 790 45 406 140 781 283 1118 277 654 769 1276 1314
1662 325 229 723 431 1092 550 319 104 542 146 963 184 94 8 520 -4 645 -19z"
        />
        <path
          d="M5197 8252 c-31 -33 -34 -52 -36 -224 l-1 -128 -580 0 -580 0 -31
-28 -32 -28 2 -465 1 -464 30 -27 30 -28 1220 0 1220 0 32 29 33 29 0 461 0
461 -28 27 -27 28 -548 5 -547 5 -5 163 -5 164 -28 24 c-39 33 -86 32 -120 -4z
m-860 -672 c7 -14 13 -53 13 -87 l0 -63 70 0 70 0 0 74 c0 83 13 106 59 106
49 0 51 -9 51 -232 0 -195 -1 -208 -19 -218 -59 -31 -91 5 -91 102 l0 68 -69
0 -69 0 -7 -77 c-7 -81 -20 -102 -60 -103 -42 0 -45 14 -45 230 0 151 3 209
12 218 21 21 71 10 85 -18z m626 16 c153 -64 173 -329 31 -412 -141 -83 -288
5 -301 181 -9 108 41 200 127 234 36 14 106 13 143 -3z m493 -12 c16 -24 16
-27 -3 -52 -14 -19 -32 -29 -59 -32 l-39 -5 0 -158 c0 -145 -2 -160 -19 -173
-29 -21 -63 -17 -80 8 -13 18 -16 53 -16 175 l0 153 -33 0 c-45 0 -77 25 -77
60 0 17 7 33 18 39 9 6 79 11 154 11 137 0 138 0 154 -26z m369 2 c13 -20 14
-29 5 -46 -15 -29 -50 -40 -126 -40 l-64 0 0 -29 c0 -29 1 -30 68 -36 82 -7
96 -14 100 -51 5 -41 -19 -54 -100 -54 l-68 0 0 -35 0 -35 84 0 c76 0 86 -2
100 -22 45 -64 6 -88 -143 -88 -161 0 -151 -15 -151 236 0 183 2 204 18 213 9
6 72 11 139 11 119 0 123 -1 138 -24z m195 9 c7 -8 11 -43 11 -87 -1 -40 2
-112 5 -160 l7 -88 75 0 c83 0 112 -15 112 -56 0 -44 -35 -55 -166 -52 -115 3
-119 4 -131 28 -20 40 -18 379 3 408 18 26 65 30 84 7z"
        />
        <path
          d="M4835 7476 c-48 -48 -42 -154 12 -195 34 -28 55 -26 92 5 74 62 39
214 -49 214 -19 0 -40 -9 -55 -24z"
        />
        <path
          d="M2830 6943 c-46 -17 -50 -31 -50 -159 0 -120 0 -123 26 -143 23 -18
41 -21 130 -21 l104 0 0 -2222 c0 -1223 3 -2233 6 -2245 l6 -23 2168 0 c1968
0 2168 1 2174 16 3 9 6 1018 6 2244 l0 2228 111 4 c148 4 149 6 149 168 0 106
-2 119 -21 136 -20 18 -42 19 -454 19 -412 0 -434 -1 -454 -19 -19 -17 -21
-30 -21 -130 0 -61 -3 -121 -6 -133 l-6 -23 -1478 0 -1478 0 -4 131 c-3 129
-3 131 -31 155 l-28 24 -417 -1 c-229 0 -424 -3 -432 -6z m1185 -739 c40 -16
45 -51 45 -329 0 -287 -5 -319 -53 -330 -12 -3 -136 -4 -276 -3 l-254 3 -21
28 c-20 27 -21 39 -21 309 l0 280 28 24 28 24 254 0 c139 0 261 -3 270 -6z
m1009 -27 c20 -27 21 -39 21 -307 l0 -278 -24 -26 -24 -26 -262 0 -262 0 -24
26 -24 26 0 283 0 283 24 26 25 26 264 -2 265 -3 21 -28z m983 9 l28 -24 3
-280 3 -279 -26 -32 -27 -31 -263 0 -263 0 -26 31 -26 31 0 269 c0 275 3 298
39 326 12 9 87 12 273 13 l257 0 28 -24z m988 -2 l25 -27 0 -282 c0 -271 -1
-283 -21 -309 l-21 -26 -271 2 -271 3 -24 35 c-23 34 -23 35 -20 308 l3 274
28 24 28 24 260 0 260 0 24 -26z m-2964 -1113 l29 -29 0 -271 c0 -177 -4 -278
-11 -294 -21 -45 -38 -48 -313 -45 l-259 3 -21 28 c-20 27 -21 42 -24 275 -2
136 0 262 3 281 4 18 18 44 32 57 l26 24 254 0 255 0 29 -29z m984 5 c13 -13
27 -39 30 -57 3 -19 5 -147 3 -286 -3 -250 -3 -252 -27 -277 l-24 -26 -262 0
-262 0 -24 26 -24 26 0 285 0 285 28 24 28 24 255 0 255 0 24 -24z m976 14
c45 -25 49 -53 49 -334 l0 -264 -26 -31 -26 -31 -258 0 c-142 0 -266 3 -275 6
-40 16 -45 51 -45 334 l0 272 29 29 29 29 252 0 c153 0 259 -4 271 -10z m1002
-18 l27 -28 0 -281 0 -280 -25 -27 -24 -26 -264 0 -264 0 -24 26 c-24 25 -24
27 -27 277 -2 139 0 267 3 286 4 18 18 44 32 57 l26 24 257 0 256 0 27 -28z
m-2957 -1105 l24 -28 0 -280 0 -281 -29 -29 -29 -29 -247 0 c-273 0 -294 4
-314 61 -7 20 -11 125 -11 281 0 282 5 310 64 327 17 5 141 9 274 8 l244 -2
24 -28z m2960 0 l24 -28 0 -280 0 -281 -29 -29 -29 -29 -252 0 c-153 0 -259 4
-271 10 -45 24 -49 54 -49 325 0 276 5 310 53 333 14 7 109 10 275 9 l254 -2
24 -28z m-1116 -962 l0 -665 -630 0 -630 0 0 665 0 665 630 0 630 0 0 -665z"
        />
        <path
          d="M5200 3328 c-11 -13 -23 -32 -26 -43 -3 -11 -4 -149 -2 -307 l3 -286
24 -26 c16 -17 35 -26 56 -26 21 0 40 9 56 26 l24 26 3 286 c2 158 0 297 -3
310 -15 60 -94 84 -135 40z"
        />
      </g>
    </svg>

    // <svg
    //   fill={color}
    //   height={sizeInPixel}
    //   width={sizeInPixel}
    //   version="1.1"
    //   id="Capa_1"
    //   xmlns="http://www.w3.org/2000/svg"
    //   xmlnsXlink="http://www.w3.org/1999/xlink"
    //   viewBox="0 0 380 380"
    //   xmlSpace="preserve"
    // >
    //   <g>
    //     <circle
    //       cx="500"
    //       cy="500"
    //       r="250"
    //       stroke="#343d71"
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     ></circle>
    //     <path
    //       d="M303.838,353.36V106.867h7.697V64.12H68.465v42.747h7.697V353.36H61.759V380h256.482v-26.64H303.838z M145.162,336.865
    //  h-40.424v-40.424h40.424V336.865z M145.162,278.32h-40.424v-40.424h40.424V278.32z M145.162,219.775h-40.424v-40.424h40.424
    //  V219.775z M145.162,161.23h-40.424v-40.424h40.424V161.23z M210.213,353.36h-40.426v-56.919h40.426V353.36z M210.213,278.32
    //  h-40.426v-40.424h40.426V278.32z M210.213,219.775h-40.426v-40.424h40.426V219.775z M210.213,161.23h-40.426v-40.424h40.426V161.23
    //  z M275.262,336.865h-40.424v-40.424h40.424V336.865z M275.262,278.32h-40.424v-40.424h40.424V278.32z M275.262,219.775h-40.424
    //  v-40.424h40.424V219.775z M275.262,161.23h-40.424v-40.424h40.424V161.23z"
    //     />
    //     <polygon
    //       points="111.373,55.757 129.489,46.232 147.606,55.757 144.146,35.584 158.803,21.297 138.548,18.354 129.489,0
    //  120.43,18.354 100.176,21.297 114.832,35.584 	"
    //     />
    //     <polygon
    //       points="171.883,55.757 190,46.232 208.117,55.757 204.656,35.584 219.313,21.297 199.059,18.354 190,0 180.941,18.354
    //  160.687,21.297 175.344,35.584 	"
    //     />
    //     <polygon
    //       points="232.394,55.757 250.511,46.232 268.627,55.757 265.168,35.584 279.824,21.297 259.57,18.354 250.511,0
    //  241.452,18.354 221.197,21.297 235.854,35.584 	"
    //     />
    //   </g>
    // </svg>
  );
};
HotelIcon.propTypes = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
HotelIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
